import React, { useEffect, useState } from 'react';
import { Carousel } from 'bootstrap';
import ContactForm from '../components/ContactForm';
import LoadingSpinner from '../components/LoadingSpinner';
import { getPage } from '../services/pageService';
import { listTestimonies } from '../services/testimonyService';

const Home = () => {
  const [historySummary, setHistorySummary] = useState('');
  const [thanksContent, setThanksContent] = useState('');
  const [summaryTestimonies, setSummaryTestimonies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadHome = async () => {
      const [historyPage, thanksPage, testimonies] = await Promise.all([
        getPage('history'),
        getPage('thanks'),
        listTestimonies({ approvedOnly: true })
      ]);
      const summaries = testimonies
        .filter((item) => item.summary)
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .slice(0, 2);

      setHistorySummary(historyPage?.summaryHtml || '');
      setThanksContent(thanksPage?.contentHtml || '');
      setSummaryTestimonies(summaries);
      setIsLoading(false);
    };
    loadHome();
  }, []);


  useEffect(() => {
    const carouselElement = document.getElementById('carouselExample');
    if (!carouselElement) {
      return undefined;
    }

    const carouselInstance = new Carousel(carouselElement, {
      interval: 500,
      ride: 'carousel',
      pause: false
    });

    return () => {
      carouselInstance.dispose();
    };
  }, []);

  const carouselSlides = [
    {
      text: "ME HAS OLVIDADO\n\n¿Recuerdas cuantas veces me buscaste agitado, con dolor en tu pecho, algunas veces con lágrimas en los ojos y hasta enfermo?",
      interval: 10000
    },
    {
      text: "Hoy me doy cuenta que solo me buscas cuando me necesitas cuando tú no eres capaz de solucionar tus problemas, tus necesidades, tus dificultades económicas y enfermedades.",
      interval: 12000
    },
    {
      text: "Me gusta cuando eres agradecido y me dices... Señor aquí estoy, gracias hoy abrí mis ojos y ahí estas regalándome tus maravillas que tienes para mí, tengo hogar y tengo familia, me das salud mucha o poca, pero estoy mejor que otros.",
      interval: 15000
    },
    {
      text: "Mi trabajo es el pan de cada día de tus manos y te tengo a Ti.\nGracias por ser mi Dios.",
      interval: 10000
    }
  ];

  return (
    <>
      <div className="container-fluid body-content">
        <div
          id="carouselExample"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="500"
          data-bs-pause="false"
        >
          <div className="carousel-inner">
            {carouselSlides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                data-bs-interval={slide.interval}
              >
                <img className="d-block w-100" src="/images/slide-1.png" alt="Oración" />
                <div className="carousel-caption d-none d-md-block">
                  <h5 className="py-2">{slide.text}</h5>
                </div>
              </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div className="container-fluid bg-color1">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="pt-4">Historia</h2>
              <div className="history">
                {isLoading ? (
                  <LoadingSpinner label="Cargando resumen..." />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: historySummary }} />
                )}
              </div>
            </div>
            <div className="col-12 py-3">
              <a className="btn btn-outline-primary" href="/historia">Ver mas</a>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-color2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="pt-4">Testimonios</h2>
              <div className="testimony">
                {isLoading ? (
                  <LoadingSpinner label="Cargando testimonios..." />
                ) : (
                  <div className="row g-3">
                    {summaryTestimonies.map((testimony) => (
                      <div className="col-12 col-md-6 d-flex" key={testimony.id}>
                        <div className="t-summary summary-card shadow mt-3 p-3 flex-fill">
                          <h3>{testimony.title}</h3>
                          <h6>{testimony.date}</h6>
                          <hr />
                          <div
                            className="summary-text"
                            dangerouslySetInnerHTML={{ __html: testimony.contentHtml }}
                          />
                          <small className="fst-italic fw-bold">
                            {testimony.name}<br />
                            {testimony.dni}<br />
                          </small>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 py-3">
              <a className="btn btn-outline-primary" href="/testimonios">Ver mas</a>
            </div>
          </div>
        </div>
      </div>

      <div id="contact" className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <h2 className="pt-4">Contactenos</h2>
          </div>
        </div>
        <ContactForm />
      </div>

      <div id="thanks" className="container-fluid py-4 bg-color3 thanks">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="pt-4 thanks">Agradecimientos</h2>
            </div>
            <div className="col-12">
              <div className="thanks">
                {isLoading ? (
                  <LoadingSpinner label="Cargando agradecimientos..." />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: thanksContent }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;